import { FC } from 'react';

import { SquareM } from 'lucide-react';
import { isEmpty, isNonNullish } from 'remeda';
import useSWR from 'swr';

import { CreateModalForm } from './createModalForm/CreateModalForm';
import { ModalCard } from './modalCard/ModalCard';

import css from './ModalSettingsPage.module.css';

import { modalSettingsService } from 'v2/api/modalSettingsService';
import { Card } from 'v2/components/card/Card';
import { CardHeader } from 'v2/components/card/cardHeader/CardHeader';
import { EmptyPlaceholder } from 'v2/components/emptyPlaceholder/EmptyPlaceholder';
import { Loader } from 'v2/components/loader/Loader';
import { PageLayout } from 'v2/components/pageLayout/PageLayout';
import { PageTitle } from 'v2/components/pageLayout/pageTitle/PageTitle';

export const ModalSettingsPage: FC = () => {
  const { data, isLoading, mutate } = useSWR('getModals', modalSettingsService.getModals);

  return (
    <PageLayout className={css.modalSettingsPage} overflow="hidden">
      <PageTitle>Modal Settings</PageTitle>

      <div className={css.modalSettingsPageContent}>
        <CreateModalForm onSuccess={mutate} />

        {isLoading ? (
          <Loader />
        ) : (
          isNonNullish(data) && (
            <Card className={css.modalSettingsPageModals}>
              <CardHeader title="All Modals" icon={SquareM} />

              <div className={css.modalSettingsPageContentCards}>
                {isEmpty(data) ? (
                  <EmptyPlaceholder />
                ) : (
                  data.map((modal) => <ModalCard key={modal.id} modal={modal} onRevalidate={mutate} />)
                )}
              </div>
            </Card>
          )
        )}
      </div>
    </PageLayout>
  );
};
